import script from "./TutorNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorNotice.vue?vue&type=script&setup=true&lang=js"

import "./TutorNotice.vue?vue&type=style&index=0&id=149f0ce4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-149f0ce4"]])

export default __exports__